import { render } from "./ComplainListLayout.vue?vue&type=template&id=473d7fdd&scoped=true"
import script from "./ComplainListLayout.vue?vue&type=script&lang=js"
export * from "./ComplainListLayout.vue?vue&type=script&lang=js"

import "./ComplainListLayout.vue?vue&type=style&index=0&id=473d7fdd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473d7fdd"]])

export default __exports__